import { render, staticRenderFns } from "./header.vue?vue&type=template&id=6050bdf1&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=6050bdf1&lang=scss&scoped=true&"
import style1 from "./header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050bdf1",
  null
  
)

export default component.exports
import {QBtn,QIcon,QChip,QAvatar,QImg,QMenu,QList,QItem,QItemSection,QSeparator,QBadge} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QIcon,QChip,QAvatar,QImg,QMenu,QList,QItem,QItemSection,QSeparator,QBadge})
